/**
 * 本地token存储
 */
import { local } from '../plugin/storage'

const TOKEN_KEY = '_token_'

export const setToken = value => {
  local.set(TOKEN_KEY, value)
}

export const getToken = () => {
  return local.get(TOKEN_KEY) || ''
}

export const removeToken = () => {
  local.remove(TOKEN_KEY)
}
